module.exports = __webpack_public_path__ + "static/media/ams-ix-avatar.89429d43.svg";